let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("696ho")).then(() => parcelRequire('fLVvK'));